import React, { ReactElement, useMemo } from 'react';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useGetClinicSettingsConversationsChannelStatusesQuery } from 'shared/types/graphql';
import { Box } from '@televet/kibble-ui/build/chakra';
import StatusBuilder from 'pages/Settings/pages/ConversationSettings/StatusBuilder';
import AutomaticStatusChanges from 'pages/Settings/pages/ConversationSettings/AutomaticStatusChanges';

const ConversationSettings = (): ReactElement => {
  const { currentClinicId } = useClinicUser();

  const { data: channelStatusesData } = useGetClinicSettingsConversationsChannelStatusesQuery({
    variables: {
      clinicId: currentClinicId || '',
    },
    skip: !currentClinicId,
    fetchPolicy: GraphQLFetchPolicies.CacheAndNetwork,
  });

  const statuses = useMemo(() => {
    return channelStatusesData?.findManyChannelStatus ?? [];
  }, [channelStatusesData]);

  return (
    <Box pb={5}>
      <StatusBuilder type={'channel'} channelStatuses={statuses} />
      <AutomaticStatusChanges channelStatuses={statuses} />
    </Box>
  );
};

export default ConversationSettings;
